// "Add page(s)" button on a checklist item. Pushes the target item to the
// server, then opens the shared file picker in the same tick so the tap still
// counts as a user gesture on iOS. LiveView processes events from one client
// in order, so set_target_item lands before the uploaded entries are consumed.
const ItemPageUpload = {
  mounted() {
    this.el.addEventListener("click", () => {
      this.pushEvent("set_target_item", { id: this.el.dataset.itemId });
      const input = document.querySelector("#item-pages-form input[type=file]");
      if (input) input.click();
    });
  },
};

export default ItemPageUpload;
